import { useContext, useMemo } from 'react';
import FeaturesContext from '../../common/context/features';

export default function useFeatureGatedDealAlerts() {
  const features = useContext(FeaturesContext);

  return useMemo(() => features?.find(f => f.n === 'deal_alerts')?.p?.receivesDealAlerts, [features]);
}
